import * as fromUI from '../state/ui.reducer';
import * as fromTurnos from '../pages/meseromesero/state/turnos/turnos.reducer';
import * as fromTurnosAsignados from '../pages/meseromesero/state/turnos-asignados/turnos-asignados-reducer';
import * as fromProductos from '../pages/meseromesero/state/productos/productos.reducer';
import * as fromRutas from '../state/rut.reducer';
import * as fromClienteSelect from '../pages/cliente-select/state/cliente-select/cliente-select-reducer'
import * as fromClienteSelectAll from '../pages/meseromesero/state/clienteselect/clienteselect.reducer'
import * as fromParametrosGenerales from '../pages/parametros-generales/state/parametrosgenerales/parametrosgenerales.reducer'
import * as fromGestionPedidos from '../pages/meseromesero/state/gestionpedidos/gestionpedidos.reducer'
import * as fromUsuarioSelect from '../pages/meseromesero/state/usuarioselect/usuarioselect.reducer'
import * as fromEstados from '../pages/meseromesero/state/estados/estados.reducer'
import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
    ui: fromUI.State;
    turnos: fromTurnos.TurnosState;
    turnosAsignados: fromTurnosAsignados.TurnosAsignadosState;
    rutas: fromRutas.RutasState;
    productos: fromProductos.ProductosState;
    clienteSelect: fromClienteSelect.IvalueDisplay;
    clienteSelectAll: fromClienteSelectAll.ClienteselectState;
    parametrosGenerales: fromParametrosGenerales.ParametrosGeneralesState;
    gestionpedidos: fromGestionPedidos.GestionpedidosState;
    usuarioSelect: fromUsuarioSelect.IvalueDisplay;
    estados: fromEstados.EstadosState;
}

export const appReducers: ActionReducerMap<AppState> = {
     ui: fromUI.uiReducer,
     turnos: fromTurnos.turnosReducer,
     rutas: fromRutas.rutasReducer,
     productos: fromProductos.productosReducer,
     turnosAsignados: fromTurnosAsignados.turnosAsignadosReducer,
     clienteSelect: fromClienteSelect.valuedisplayreducer,
     clienteSelectAll:fromClienteSelectAll.clienteselectReducer,
     parametrosGenerales: fromParametrosGenerales.parametrosGeneralesReducer,
     gestionpedidos: fromGestionPedidos.gestionpedidosReducer,
     usuarioSelect: fromUsuarioSelect.valuedisplayreducer,
     estados: fromEstados.estadosReducer,
};



// WEBPACK FOOTER //
// ./src/app/app.reducer.ts